import React from 'react';
import styled from 'styled-components';

import { COLORS } from 'config/constants/styles';
import Avatar, { LabelAvatar, ArtistAvatar } from 'components/Avatar';
import TextHeader from 'components/TextHeader';
import { ContainerPaddingCss, InverseContainerCss } from 'components/Layout/Container';

/**
 * This file contains a variety of styled components common for building a mobile table=
 */

export const MobileRow = styled.div<{ disabled?: boolean; $tombstone?: boolean }>`
  background: ${COLORS.WHITE};
  ${InverseContainerCss}
  position: relative;
  border-bottom: 1px solid ${COLORS.GRAY_LIGHTEST};
  ${({ disabled }) =>
    disabled &&
    `
     &:after {
       background: rgba(255, 255, 255, 0.4);
       content: '';
       display: block;
       height: 100%;
       width: 100%;
       position: absolute;
     }
   `}
  &:hover {
    background: ${({ $tombstone }) => !$tombstone && COLORS.GRAY_SUPER_LIGHT};
  }
`;

export const MobileRowContent = styled.div<{ $success?: boolean }>`
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  overflow: hidden;
  padding: 0.5rem 0;
  ${ContainerPaddingCss}
  position: relative;
  ${({ $success }) => $success && `opacity: 0.6;`}
`;

export const MobileRowMeta = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1rem;
  flex: 1 1 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  position: relative;
`;

const StyledMobileRowHeader = styled(TextHeader)`
  flex: 1;
  margin-bottom: 0;
`;
export const MobileRowHeader = ({
  children,
  ...props
}: {
  children: React.ReactNode;
}) => (
  <StyledMobileRowHeader
    type={TextHeader.TYPES.MEDIUM}
    weight={TextHeader.WEIGHTS.HEAVY}
    {...props}
  >
    {children}
  </StyledMobileRowHeader>
);

interface Props {
  imageUrl?: string | null;
  type: string;
  loading?: boolean;
}

export const MobileRowImage = ({ type, imageUrl, loading }: Props) => {
  if (type === 'label') {
    return (
      <LabelAvatar
        imageUrl={imageUrl}
        size={Avatar.SIZES.LARGE}
        altTag="Label Art"
        lazy={false}
        loading={loading}
      />
    );
  }

  if (type === 'artist') {
    return (
      <ArtistAvatar
        imageUrl={imageUrl}
        size={Avatar.SIZES.LARGE}
        lazy={false}
        loading={loading}
      />
    );
  }

  return null;
};
